import {BaseApi} from './BaseApi'

export interface AgencyPledgeDetail {
  agencyId: string
  agencyName: string
  quantityPledged: number
  status: string // AgencyServiceOrderStatus enum
}

export interface AgencyPledgeBreakdownResponse {
  jobOrderId: string
  position: string
  shift: string
  quantityRequested: number
  totalPledged: number
  agencySummary: string
  agencyPledges: AgencyPledgeDetail[]
  candidatesAvailable: number
}

export interface JobOrderWithinServiceOrderResponse {
  id: string
  position: string
  quantity: number
  status: string
  agencyDistributions: any[] // Define more specifically if needed
}

/**
 * Job Order API Service
 * Handles all job order related operations
 */
export class JobOrderApi extends BaseApi {
  /**
   * Get agency pledge breakdown for a job order
   * GET /api/joborder/getAgencyPledgeBreakdown/:jobOrderId
   */
  async getAgencyPledgeBreakdown(jobOrderId: string): Promise<AgencyPledgeBreakdownResponse> {
    try {
      const response = await this.client.get<AgencyPledgeBreakdownResponse>(
        `/api/joborder/getAgencyPledgeBreakdown/${jobOrderId}`,
      )
      return response.data
    } catch (error: unknown) {
      console.error('Error fetching agency pledge breakdown for job order:', jobOrderId, error)
      throw error
    }
  }

  /**
   * Get job orders by service order
   * GET /api/joborder/getJobOrdersByServiceOrder/:serviceOrderId
   */
  async getJobOrdersByServiceOrder(
    serviceOrderId: string,
  ): Promise<JobOrderWithinServiceOrderResponse[]> {
    try {
      const response = await this.client.get<JobOrderWithinServiceOrderResponse[]>(
        `/api/joborder/getJobOrdersByServiceOrder/${serviceOrderId}`,
      )
      return response.data
    } catch (error: unknown) {
      console.error('Error fetching job orders by service order:', serviceOrderId, error)
      throw error
    }
  }
}

// Export singleton instance
export const jobOrderApi = new JobOrderApi()
